module.exports = __webpack_public_path__ + "img/tee-number.569723a6.svg";